import type { MutableRefObject } from 'react';

export function trackReportFetchStart(inFlightRef: MutableRefObject<number>): void {
  inFlightRef.current += 1;
}

export function trackReportFetchEnd(
  inFlightRef: MutableRefObject<number>,
  setReportLoading: (loading: boolean) => void
): void {
  inFlightRef.current = Math.max(0, inFlightRef.current - 1);
  if (inFlightRef.current === 0) {
    setReportLoading(false);
  }
}
